/**
 * @generated SignedSource<<ae96c4be1d3635ad3b8711512fc94d5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaediaPredefinedTemplateCreateBranchRootNodeInput = {
  category?: string | null | undefined;
  certificateTemplateId?: string | null | undefined;
  certifierRef?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  length?: number | null | undefined;
  pacPointsAmount?: number | null | undefined;
  pharmaPointsAmount?: number | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  title: string;
  validFrom?: any | null | undefined;
  validTo?: any | null | undefined;
  vnrInternalNumber?: string | null | undefined;
  vnrNumber?: string | null | undefined;
  vnrPassword?: string | null | undefined;
};
export type projectCreateTreeButton_CreateBranchRootNodeMutation$variables = {
  connections: ReadonlyArray<string>;
  input: PaediaPredefinedTemplateCreateBranchRootNodeInput;
};
export type projectCreateTreeButton_CreateBranchRootNodeMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly paediaPredefinedTemplateCreateBranchRootNode: {
        readonly createdRootNode: {
          readonly node: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"RootNodesTable_TreeNodeFragment">;
          };
        };
      } | null | undefined;
    };
  };
};
export type projectCreateTreeButton_CreateBranchRootNodeMutation = {
  response: projectCreateTreeButton_CreateBranchRootNodeMutation$data;
  variables: projectCreateTreeButton_CreateBranchRootNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardExpired",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateTime",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "NotAfterDateTimeVisibilityTreeConfig",
  "abstractKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "AfterDateTimeVisibilityTreeConfig",
  "abstractKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "projectCreateTreeButton_CreateBranchRootNodeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "PaediaPredefinedTemplateCreateBranchRootNodePayload",
                "kind": "LinkedField",
                "name": "paediaPredefinedTemplateCreateBranchRootNode",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNodesEdge",
                    "kind": "LinkedField",
                    "name": "createdRootNode",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "RootNodesTable_TreeNodeFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "structureDefinition",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "extension",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TreeConfigConsequences",
                                                "kind": "LinkedField",
                                                "name": "configConsequences",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "RootExtensionImpl",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "visibilityConfigs",
                                        "plural": true,
                                        "selections": [
                                          (v5/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v3/*: any*/),
                                              (v6/*: any*/)
                                            ],
                                            "type": "OnlySpecificPermissionsVisibilityTreeConfig",
                                            "abstractKey": null
                                          },
                                          (v8/*: any*/),
                                          (v9/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "RootStructureDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ActionColumn_TreeNodeFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ConfigurationBadgesColumn_TreeNodeFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ContentColumn_TreeNodeFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IsRewardedToColumn_TreeNodeFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ReleasedAtColumn_TreeNodeFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "TagsColumn_TreeNodeFragment"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "TitleColumn_TreeNodeFragment"
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "projectCreateTreeButton_CreateBranchRootNodeMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "PaediaPredefinedTemplateCreateBranchRootNodePayload",
                "kind": "LinkedField",
                "name": "paediaPredefinedTemplateCreateBranchRootNode",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNodesEdge",
                    "kind": "LinkedField",
                    "name": "createdRootNode",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TreeConfigConsequences",
                                            "kind": "LinkedField",
                                            "name": "configConsequences",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isRewardedTo",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "displayType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AdvertisementConfiguration",
                                            "kind": "LinkedField",
                                            "name": "advertisementConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isFeatured",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "RootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "visibilityConfigs",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v5/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v7/*: any*/),
                                        "type": "OnlySpecificPermissionsVisibilityTreeConfig",
                                        "abstractKey": null
                                      },
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "firstReleasedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "colorHex",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "type": "RootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasBeenPublishedOnce",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "rewards",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "kind",
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ContentTypeDefinition",
                                "abstractKey": "__isContentTypeDefinition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": true,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Versioning",
                            "kind": "LinkedField",
                            "name": "versioning",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "draftVersion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "releaseVersion",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "createdRootNode",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5580768e9bbf4737a4f68582cbacc92f",
    "id": null,
    "metadata": {},
    "name": "projectCreateTreeButton_CreateBranchRootNodeMutation",
    "operationKind": "mutation",
    "text": "mutation projectCreateTreeButton_CreateBranchRootNodeMutation(\n  $input: PaediaPredefinedTemplateCreateBranchRootNodeInput!\n) {\n  Admin {\n    Tree {\n      paediaPredefinedTemplateCreateBranchRootNode(input: $input) {\n        createdRootNode {\n          node {\n            id\n            ...RootNodesTable_TreeNodeFragment\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ActionColumn_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n        }\n      }\n    }\n  }\n  ...ProjectExtendActionButtons_TreeNodeFragment\n}\n\nfragment ConfigurationBadgesColumn_TreeNodeFragment on TreeNode {\n  ...NodeConfigurationBadges_TreeNodeFragment\n  ...ProjectExtendNodeConfigurationBadges_TreeNodeFragment\n}\n\nfragment ContainerTag_TagFragment on Tag {\n  id\n  name\n  colorHex\n}\n\nfragment ContentColumn_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ELearningContentTypeDefinition {\n      elements {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment IsRewardedToColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          configConsequences {\n            isRewardedTo\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    definitionType\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n          configConsequences {\n            isRewardedTo\n          }\n          advertisementConfig {\n            isFeatured\n          }\n        }\n      }\n    }\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n  versioning {\n    draftVersion\n    releaseVersion\n  }\n}\n\nfragment PreviewPublishedNodeActionButton_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectExtendActionButtons_TreeNodeFragment on TreeNode {\n  ...PreviewPublishedNodeActionButton_TreeNodeFragment\n}\n\nfragment ProjectExtendNodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n}\n\nfragment ReleasedAtColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      firstReleasedAt\n    }\n  }\n}\n\nfragment RootNodesTable_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          configConsequences {\n            rewardExpired\n          }\n        }\n      }\n      visibilityConfigs {\n        __typename\n        configType\n        ... on OnlySpecificPermissionsVisibilityTreeConfig {\n          id\n          configType\n          dateTime\n        }\n        ... on NotAfterDateTimeVisibilityTreeConfig {\n          dateTime\n        }\n        ... on AfterDateTimeVisibilityTreeConfig {\n          dateTime\n        }\n        id\n      }\n    }\n  }\n  ...ActionColumn_TreeNodeFragment\n  ...ConfigurationBadgesColumn_TreeNodeFragment\n  ...ContentColumn_TreeNodeFragment\n  ...IsRewardedToColumn_TreeNodeFragment\n  ...ReleasedAtColumn_TreeNodeFragment\n  ...TagsColumn_TreeNodeFragment\n  ...TitleColumn_TreeNodeFragment\n}\n\nfragment TagsColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      tags {\n        id\n        ...ContainerTag_TagFragment\n      }\n    }\n  }\n}\n\nfragment TitleColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      icon {\n        url\n        id\n      }\n      title\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87101b2e806b16cdcda4e71bdc2442ea";

export default node;
